import classNames from 'classnames';
import moment from 'moment';
import { useMemo } from 'react';

import { SafeInnerHtmlSetter } from 'components/shared/util/SafeInnerHtmlSetter';
import { markdownToHtml } from 'utils/markdown';

import styles from './mimSidekickMessage.module.scss';

type MimSidekickMessageProps = {
  role: 'user' | 'assistant' | 'system';
  text: string;
};

const ISO_8601 =
  /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:?\d{2})?/g;

const parseAsUtc = (value: string): Date =>
  new Date(/(?:Z|[+-]\d{2}:?\d{2})$/.test(value) ? value : `${value}Z`);

const TIMESTAMP_FORMAT = 'MMM D, YYYY · hh:mm:ss A';

const localizeMessageTimestamps = (text: string): string =>
  text.replace(ISO_8601, (match) => {
    const date = parseAsUtc(match);
    return Number.isNaN(date.getTime())
      ? match
      : moment(date).format(TIMESTAMP_FORMAT);
  });

export const MimSidekickMessage = ({
  role,
  text,
}: MimSidekickMessageProps): JSX.Element => {
  const isUser = role === 'user';
  const html = useMemo(
    () => markdownToHtml(localizeMessageTimestamps(text)),
    [text],
  );
  return (
    <SafeInnerHtmlSetter
      element="div"
      className={classNames(styles.bubble, {
        [styles.bubbleUser]: isUser,
        [styles.bubbleAssistant]: !isUser,
      })}
      content={html}
    />
  );
};
